import {Dialog, Transition} from "@headlessui/react";
import {Fragment, useEffect, useRef, useState} from "react";
import {useSelector} from "react-redux";
import saveItem, {getList} from "../../services/service";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import ToggleWithLabel from "../ToggleWithLabel";
import {toast} from "react-toastify";

export default function ModalAddInsertsAdditional({
                                                      open,
                                                      handleClose,
                                                      consistId,
                                                      id,
                                                      fetchData, isEdit
                                                  }) {
    const cancelButtonRef = useRef(null);
    const {token} = useSelector((state) => state.user);
    const [name, setName] = useState(null);
    const [byDefault, setByDefault] = useState(false);
    const [necessarily, setNecessarily] = useState(false);
    const navigate = useNavigate();
    const {t} = useTranslation();

    useEffect(() => {
        if (!open) {
            setName(null);
            setByDefault(false)
            setNecessarily(false)
        }
    }, [consistId, open]);

    useEffect(() => {
        if (isEdit) {
            const getData = async () => {
                const response = await getList(`${process.env.REACT_APP_HOST_BASE_URL}/v1/additional/${id}`, token);
                console.log(response, 'response');
                if (response.success) {
                    setName(response.data?.name);
                    setByDefault(response.data?.byDefault)
                    setNecessarily(response.data?.necessarily)
                }
            }

            getData();
        }
    }, [id]);
    const handleSubmit = async (evt) => {
        evt.preventDefault();
        const response = await saveItem(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/additional`,
            token,
            {
                id: id ? id : null,
                name: name,
                byDefault: byDefault,
                necessarily: necessarily,
                consistId: consistId,
            }
        );
        if (response.success) {
            fetchData();
            handleClose();
            toast.success(t('action.add_success'), {
                position: "bottom-right",
                autoClose: 3000,
                closeOnClick: true,
                className: "add-success"
            });
        } else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog
                as="div"
                className="relative z-10"
                initialFocus={cancelButtonRef}
                onClose={handleClose}
            >
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"/>
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex items-end justify-center min-h-full p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel
                                className="relative px-4 pt-5 pb-4 text-left transition-all transform bg-white rounded-lg shadow-xl  sm:my-8 sm:w-full sm:max-w-lg sm:p-6 ">
                                <form onSubmit={handleSubmit}>
                                    <div className="sm:mb-5">
                                        <Dialog.Title
                                            as="h3"
                                            className="text-lg font-medium leading-6 text-gray-900 "
                                        >
                                            {t('add_additional')}
                                        </Dialog.Title>
                                        <div className="grid grid sm:grid-cols-12 gap-2">
                                            <div className="mt-5 col-span-12 sm:col-span-12">
                                                <label
                                                    htmlFor="name"
                                                    className="block text-sm font-medium text-gray-700"
                                                >
                                                    {t('name')}
                                                </label>
                                                <input
                                                    type="text"
                                                    name="name"
                                                    id="name"
                                                    required
                                                    value={name}
                                                    onChange={(e) => {
                                                        setName(e.target.value);
                                                    }}
                                                    className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                />
                                            </div>
                                            <div className="mt-5 col-span-12 sm:col-span-6">
                                                <ToggleWithLabel
                                                    label={t('default')}
                                                    enabled={byDefault}
                                                    setEnabled={setByDefault}
                                                />
                                            </div>
                                            <div className="mt-5 col-span-12 sm:col-span-6">
                                                <ToggleWithLabel
                                                    label={t('necessarily')}
                                                    enabled={necessarily}
                                                    setEnabled={setNecessarily}
                                                />
                                            </div>
                                        </div>

                                    </div>
                                    <div
                                        className="mt-8 sm:mt-10 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                                        <button
                                            type="submit"
                                            className="inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:col-start-2 sm:text-sm"
                                        >
                                            {t('save')}
                                        </button>
                                        <button
                                            type="button"
                                            className="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:col-start-1 sm:mt-0 sm:text-sm"
                                            onClick={handleClose}
                                            ref={cancelButtonRef}
                                        >
                                            {t('cancel')}
                                        </button>
                                    </div>
                                </form>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}
